export const LANDING = '/';
export const SIGN_IN = '/login';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const ADMIN = '/admin';
export const REPORTS = '/reports';
export const DEFAULT = REPORTS;